import React, { useCallback, useEffect, useState } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { faPencilAlt, faXmark } from "@fortawesome/free-solid-svg-icons";
import InputComponent from '../../Customer/AddCustomers/InputComponent';
import middleware from '../../Api/Middleware';
import ToastError from '../../Toasts/ToastError';
import ToastInfo from '../../Toasts/ToastInfo';
import ToastSuccess from '../../Toasts/ToastSuccess';
import { BorderedTextInput } from '../../HouseStyle/Components/Inputs';
import { BorderedDropDown } from '../../HouseStyle/Components/DropDowns';
import Phonenumber from '../../Customer/Components/Phonenumber';

const AddPhoneModal = (props) => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({country_code: "", phone_number: ""});


    const addPhone = async () => {
        if (!formData.country_code) {
            ToastError('Selecteer een landcode.', 'empty_country_code');
            return;
        }

        if (!formData.phone_number) {
            ToastError('Vul een telefoonnummer in.', 'empty_phone_number');
            return;
        }

        if (formData.phone_number.length < 8) {
            ToastError('Telefoonnummer moet minimaal 8 cijfers bevatten.', 'to_short_phone_number');
            return;
        }

        if (formData.phone_number.length > 15) {
            ToastError('Telefoonnummer mag maximaal 15 cijfers bevatten.', 'to_long_phone_number');
            return;
        }

        try {
            const phonenumbersRes = await middleware.post("/phonenumbers", {
                internal_id: props.customer.internal_id,
                country_phone_prefix: formData.country_code,
                phone_number: formData.phone_number
            });
            const newPhoneNumber = phonenumbersRes.data.data

            ToastSuccess("Telefoonnummer is aangemaakt.");
            props.setSelectedPhone(newPhoneNumber);
            
            if(props?.order?.client_phonenumbers) {
                props.setOrder({...(props.order), client_phonenumbers: [...props.order.client_phonenumbers, newPhoneNumber]});
            } else {
                props.setPhones([...props.phones, newPhoneNumber]);
            }
            props.setAddPhoneModalVisible(false);
        } catch (error) {
            console.log(error.response.data.error.phone_number.length);
            
            if (error.response?.data?.error?.phone_number?.length > 0) {
                ToastError(error.response?.data?.error?.phone_number[0]);
            } else {
                ToastError('Er is iets fout gegaan tijdens het maken van het telefoonnummer. Porbeer het later opnieuw');
            }
        }
    }

    const handlePhoneNumberChange = phoneNumber => {
        const sanitizedPhoneNumber = phoneNumber.replace(/[^0-9]/g, '');
        if (sanitizedPhoneNumber.length > 15) {
            ToastError('Telefoonnummer mag maximaal 15 cijfers bevatten.', 'to_long_phone_number');
            return;
        }
        setFormData({ ...formData, phone_number: sanitizedPhoneNumber });
    };

    const handleClose = () => {
        props.setAddPhoneModalVisible(false);
    };

    return (
        <Modal
            id="modalItemNote"
            show={props.addPhoneModalVisible}
            onHide={handleClose}
            className="colormodals"
            size="xl"
            centered
        >
            <Modal.Header className="modalTop justify-content-between" >
                <h4 className="mb-0 fw-semibold">Telefoonnummer toevoegen</h4>
                <button variant="transparent" className=' btn' onClick={() => { props.setAddPhoneModalVisible(false) }}>
                    <FontAwesomeIcon icon={faXmark} className="closeModal" />
                </button>
            </Modal.Header>
            <Modal.Body className="modalCenter d-flex flex-column">
                <div className="">
                    <div className='mb-3'>
                    <Phonenumber removable={false} phonenumber={{country_phone_prefix: formData.country_code, phone_number: formData.phone_number}} handlePhoneNumberChange={handlePhoneNumberChange} setPhoneCode={(phone_prefix) => setFormData({...formData, country_code: phone_prefix})}/>
                    </div>
                   
                </div>
            </Modal.Body>
            <Modal.Footer className="modalBottom">
                 <div className="d-flex justify-content-between">
                        <button className="btn DarkStandardButton" type="button" onClick={() => { props.setAddPhoneModalVisible(false) }}>Annuleren</button>
                        <button className="btn lightBlueStandardButton" onClick={() => addPhone()}>{"Toevoegen"}</button>
                    </div>
            </Modal.Footer>
        </Modal>
    )
}

export default AddPhoneModal
